export const isTabletOrIpad = () => {
    const ua = navigator.userAgent.toLowerCase();

    // iPad check (also covers iPadOS 13+ which shows as "Macintosh")
    const isIpad =
        /\b(ipad)\b/.test(ua) ||
        (navigator.userAgent.includes(`Macintosh`) && 'ontouchend' in document);

    // Android tablet: has "android" but not "mobile"
    const isAndroidTablet = /android/.test(ua) && !/mobile/.test(ua);

    // Other tablets (Kindle, Playbook, Windows touch tablets)
    const otherTabletRegex =
        /(macintosh.*?tablet|windows(?!.*phone)(.*touch)|kindle|playbook|silk.*$)/i;

    const isOtherTablet = otherTabletRegex.test(ua);

    return isIpad || isAndroidTablet || isOtherTablet;
};
export default isTabletOrIpad;
